import { useMutation } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";
import toast from "react-hot-toast";

export const useDeleteItem = () => {
  return useMutation({
    mutationFn: async (url: string) => {
      const res = await httpRequest.delete(`${url}`);
      return res.data;
    },
    onSuccess: () => {},
    onError: (error: any) => {
      const message =
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong while deleting.";
      toast.error(message);
      console.error("Error deleting superannuation:", error);
    },
  });
};
